module.exports = __webpack_public_path__ + "static/media/nerdify-icon-1.9067c5db.svg";